import { useMutation } from '@apollo/react-hooks'

import { UPSERT_COUNTRY_MUTATION, ALL_COUNTRIES_QUERY } from '../../queries/localization'
import { IUpsertCountryData, IUpsertCountryVariables, IUpsertCountryInput } from '../../types/localization'

export const useUpsertCountry = () => {
  const [upsertCountryMutation, { loading, error }] = useMutation<IUpsertCountryData, IUpsertCountryVariables>(
    UPSERT_COUNTRY_MUTATION
  )

  const upsertCountry = async (input: IUpsertCountryInput) => {
    try {
      await upsertCountryMutation({
        variables: { input },
        refetchQueries: [{ query: ALL_COUNTRIES_QUERY }],
      })
    } catch (error) {
      console.log(error)
    }
  }

  return {
    loading,
    error,
    upsertCountry,
  }
}
